import {
	Job,
	ContractRates,
	Division,
	PrevailingWageInfo,
	DateRange,
	OtherChargeItem,
	PagedResultsOfQuoteLogSummary,
	OfferedService,
	PagedResultsOfAuditTrail,
} from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { JobDetails } from '../job-detail.models';
import * as moment from 'moment';
import { PayrollMonthlyReportArgs } from '../../shared/payroll-monthly-report-dialog/payroll-monthly-report-dialog.component';

export const jobTurnedIntoJob = createAction('[Jobs] Job Turned Into Job');

export const jobSaved = createAction('[Jobs] Job Saved', props<{ job: Job }>());

export const newJobSaved = createAction(
	'[Jobs] New Job Saved',
	props<{ job: Job }>()
);

export const editBillingInfoToggled = createAction(
	'[Jobs] Edit Billing Info',
	props<{ editBillingInfo: boolean }>()
);

export const jobDatesExtended = createAction('[Jobs] Job Dates Extended');

export const otherChargesSaved = createAction('[Jobs] Other Charges Saved');

export const otherChargeItemsLoaded = createAction(
	'[Jobs] Other Charge Items Loaded',
	props<{ otherCharges: OtherChargeItem[] }>()
);

export const offeredServicesUpdated = createAction(
	'[Jobs] Offered Services Updated',
	props<{ offeredServices: OfferedService[] }>()
);

export const quoteLogsRequested = createAction('[Jobs] Quote Logs Requested');

export const pagedQuoteLogsLoaded = createAction(
	'[Job Detail Quote Logs] Paged Quote Logs Loaded',
	props<{
		pagedQuoteLogResults: PagedResultsOfQuoteLogSummary;
	}>()
);

export const shiftsAddedOutsideOfJobDates = createAction(
	'[Jobs] Shifts Added Outside of Job Dates',
	props<{ newDateRange: DateRange }>()
);
export const errorSavingJob = createAction(
	'[Jobs] Error Saving Job',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Jobs] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: JobDetails }>()
);

export const userConfirmedPrevailingWage = createAction(
	'[Jobs] User Confirmed Prevailing Wage',
	props<{ jobForm: JobDetails }>()
);

export const userConfirmedCancelJob = createAction(
	'[Jobs] User Confirmed Cancel Job',
	props<{ jobForm: JobDetails }>()
);

export const userConfirmedRequestNewJobSetupForm = createAction(
	'[Jobs] User Confirmed Request New Job Setup Form',
	props<{ jobForm: JobDetails }>()
);

export const userConfirmedCompleteJob = createAction(
	'[Jobs] User Confirmed Complete Job',
	props<{ jobForm: JobDetails }>()
);

export const documentsLoaded = createAction(
	'[Jobs] Documents Loaded',
	props<{ documents: Document[] }>()
);

export const prevailingWagesConfirmed = createAction(
	'[Jobs] Prevailing Wages Confirmed',
	props<{ prevailingWageInfo: PrevailingWageInfo }>()
);

export const jobApprovedByRailPros = createAction(
	'[Jobs] Job Approved By RailPros'
);

export const jobDetailDestroyed = createAction('[Jobs] Job Detail Destroyed');

export const jobSelectedForAssignments = createAction(
	'[Job Assignments Page] Job Selected',
	props<{ jobId: number }>()
);

export const jobSelected = createAction(
	'[Jobs] Job Selected',
	props<{ jobId: number }>()
);

export const jobLoadedFromApi = createAction(
	'[Jobs] Job Loaded From Api',
	props<{ job: Job }>()
);

export const jobLoadedFromStore = createAction(
	'[Jobs] Job Loaded From Store',
	props<{ job: Job }>()
);

export const errorLoadingJob = createAction(
	'[Jobs] Error Loading Job',
	props<{ error: any }>()
);

export const newJobStarted = createAction('[Jobs] New Job Started');

export const railroadRatesApplied = createAction(
	'[Jobs] Railroad Rates Applied',
	props<{ contractedRates: ContractRates }>()
);

export const customerRatesApplied = createAction(
	'[Jobs] Customer Rates Applied',
	props<{ contractedRates: ContractRates }>()
);

export const railroadSelected = createAction(
	'[Jobs] Railroad Selected',
	props<{ railroadId: number }>()
);

export const railroadRequested = createAction(
	'[Jobs] Railroad Requested',
	props<{ railroadId: number }>()
);

export const customerRequested = createAction(
	'[Jobs] Customer Requested',
	props<{ customerId: number }>()
);

export const customerSelected = createAction(
	'[Jobs] Customer Selected',
	props<{ customerId: number }>()
);

export const divisionSelected = createAction(
	'[Jobs] Division Selected',
	props<{ division: Division }>()
);

export const openAddShiftDialog = createAction(
	'[Job Assignments Page] Open Shift Dialog',
	props<{ startDate: moment.Moment; endDate: moment.Moment }>()
);

export const ShiftsAddedFromAssignmentsOutsideOfJobDates = createAction(
	'[Job Assignments Page] Shifts Added Outside of Job Dates',
	props<{ newDateRange: DateRange }>()
);

export const railroadRequestedFromAssignments = createAction(
	'[Job Assignments Page] Railroad Requested',
	props<{ railroadId: number }>()
);

export const confirmedGeneratePayrollMonthlyReportCsv = createAction(
	'[Job Detail] Confirmed Generate Payroll Monthly Report CSV',
	props<{ args: PayrollMonthlyReportArgs }>()
);

export const pagedJobLogsLoaded = createAction(
	'[Job Detail Job Logs] Paged Job Logs Loaded',
	props<{
		pagedJobLogResults: PagedResultsOfAuditTrail;
	}>()
);
